import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import { notification } from 'antd';

import { useParams } from "react-router";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  }
});

class Edit extends React.Component {
  constructor(props) {
    super(props);

    const cid = props.id;

    this.state = {
      name: '',
      serial: '',
      device_id: '',
      id: cid,
      empresa_data: [],
      id_company: '',
      status: 'Ativo',
      tipo: 'Aeronave'
    };
  }

  componentDidMount() {
    if (this.state.id) {
      const apiUrl = Config.server + '/module/' + this.state.id;

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.json();
        })
        .then(
          (result) => {
            if (result.length > 0) {
              this.setState({
                name: result[0].name,
                serial: result[0].serial,
                device_id: result[0].device_id,
                id_company: result[0].id_company,
              });
            }
          },
          (error) => {
            if (error.status === 401) {
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
    this.updateList();
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    let apiUrl = '';
    let method = '';
    apiUrl = Config.server + '/module/';
    if (!this.state.id_company) {
      notification.open({
        message: this.props.res.MSG_INFORME_EMPRESA,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    } else if (!this.state.serial) {
      notification.open({
        message: this.props.res.MSG_INFORME_SERIAL,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    const formData = new URLSearchParams();
    if (this.state.id) {
      apiUrl += this.state.id;
      formData.append('id', this.state.id);
      method = 'PUT';
    } else {
      method = 'POST';
    }

    formData.append('name', this.state.name);
    formData.append('status', this.state.status);
    formData.append('type', this.state.tipo);
    formData.append('serial', this.state.serial);
    formData.append('device_id', this.state.device_id);
    formData.append('id_company', this.state.id_company);

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          let msg = this.props.res.ITEM_INCLUIR;
          if (this.state.id) {
            msg = this.props.res.ITEM_ALTERADO;
          }
          notification.open({
            message: this.props.res.SUCESSO,
            description: msg,
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
          if (!this.state.id) {
            this.setState({
              name: '',
              serial: '',
              id_company: '',
              status: 'Ativo',
              tipo: 'Aeronave'
            });
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  updateList = () => {
    const apiUrl = Config.server + '/company';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            empresa_data: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  render() {
    const { classes, link, res } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="containerTop">
          <div><h1>{res.MODULO}</h1></div>
          <div className="centerTop"></div>
          <div>
            <Button variant="contained" onClick={evemt => { link('/app/cadastro/modulo/list') }} className="popUpButton">
              {res.CANCELAR}
            </Button> &nbsp;
            <Button type="submit" variant="contained" color="primary" className="popUpButton">
              <SaveIcon className="iconMapS" />
              {res.SALVAR}
            </Button>
          </div>
        </div>
        <div className="form-group notTooBig">
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="age-simple">{res.EMPRESA}</InputLabel>
            <Select
              value={this.state.id_company}
              onChange={this.handleChange('id_company')}
              inputProps={{
                id: 'id_company',
              }}
            >
              {this.state.empresa_data.map(n => {
                return (
                  <MenuItem value={n.id}>{n.nick_name}</MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <TextField
            id="name"
            label={res.NOME}
            className={classes.textField}
            value={this.state.name}
            onChange={this.handleChange('name')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="serial"
            label={res.SERIAL}
            className={classes.textField}
            value={this.state.serial}
            onChange={this.handleChange('serial')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="device_id"
            label={res.DEVICEID}
            className={classes.textField}
            value={this.state.device_id}
            onChange={this.handleChange('device_id')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = isNaN(e.target.value.slice(-1)) ? e.target.value.slice(0, -1) : e.target.value
            }}
          />
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="age-simple">{res.TIPO}</InputLabel>
            <Select
              value={this.state.tipo}
              onChange={this.handleChange('tipo')}
              inputProps={{
                id: 'tipo',
              }}
            >
              <MenuItem value={'Aeronave'}>{res.AERONAVE}</MenuItem>
              <MenuItem value={'Suporte'}>{res.SUPORTE}</MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="age-simple">{res.STATUS}</InputLabel>
            <Select
              value={this.state.status}
              onChange={this.handleChange('status')}
              inputProps={{
                id: 'status',
              }}
            >
              <MenuItem value={'Ativo'}>{res.ATIVO}</MenuItem>
              <MenuItem value={'Inativo'}>{res.INATIVO}</MenuItem>
            </Select>
          </FormControl>
        </div>
      </form>
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res } = props;
  let { id } = useParams();
  return (
    <div className="rowForm">
      <div className="divContent">
        <TextFields1 link={link} id={id} res={res} />
      </div>
    </div>)
}

export default Box;

